module.exports = __webpack_public_path__ + "d1f4aab7b68e7542b31d007a2c6f72cc.jpg";